/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { useAsyncFocusBlur as l } from "../hooks/useAsyncFocusBlur.mjs";
const a = ({
  children: o,
  onFocus: t,
  onBlur: c,
  onSyncFocus: e,
  onSyncBlur: s
}) => {
  const n = l({ onFocus: t, onBlur: c, onSyncFocus: e, onSyncBlur: s });
  return /* @__PURE__ */ r.createElement(r.Fragment, null, o.call(void 0, { ...n }));
};
export {
  a as AsyncFocusBlur
};
